exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".social-share-theme-modal-overlay{position:absolute;top:0;left:0;height:100%;width:100%;z-index:1}.social-share-theme-modal-overlay.is-light{background-color:hsla(0,0%,100%,.6)}.social-share-theme-modal-overlay.is-dark{background-color:rgba(0,0,0,.6)}", ""]);

// exports
